import { render } from "./feature.vue?vue&type=template&id=e24ae782"
const script = {}

import "./feature.vue?vue&type=style&index=0&id=e24ae782&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__